import React, { useState, useEffect } from 'react';
import { Row, Col, Modal, Button, Form, OverlayTrigger, Tooltip, FormGroup } from 'react-bootstrap';
import Card from '../../../components/Card'; // Assuming the same Card component is used
import { getApiCall, fetchAndSetFlashMessage } from '../../../service/httpCall';
import { API_AGENTS_LIST, API_SINGLE_AGENT_GROUP, API_AGENT_GROUP_ASSIGNED_AGENTS, API_AGENT_GROUP_STRATEGY, API_PROMPT_ACTIVE_LIST, API_CALL_STRATEGIES_MASTER_LIST, API_AGENT_GROUP_AVAILABLE_INBOUND_NUMBERS, API_AGENT_GROUP_CLI_ALLOCATIONS_SYNC, API_CALL_SCRIPT_LIST, API_MOH_ACTIVE } from '../../../service/url';
import { useLocation, useParams } from 'react-router-dom';
import { postApiCall } from '../../../service/postApiCall';
import { useNavigate } from 'react-router-dom';
// import { Toaster, toast } from 'react-hot-toast';
import LottieAnimation from '../../../components/lottie/lottie';
import './slider.css'
import { MultiSelect } from 'primereact/multiselect';
import { DeleteIcon, EditIcon } from '../../../components/setting/elements';
import { FiInfo } from 'react-icons/fi';
import { MODULE_ACL, FLASH_MESSAGE_ACTION_OBJECT, USER_ROLES } from '../../../utilities/constant';
import { toast } from "react-toastify";
import { Storage } from '../../../utilities/setting';

const GroupSettings = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { id: routeGroupId } = useParams();
    const groupId = location.state?.groupId ?? routeGroupId;
    const [showAddMembersModal, setShowAddMembersModal] = useState(false);
    const [agentGroup, setAgentGroup] = useState({});
    const [showTimeScheduleModal, setShowTimeScheduleModal] = useState(false);
    const [showWhisperModal, setShowWhisperModal] = useState(false);
    const [agents, setAgents] = useState([]);
    const [showCallStrategyModal, setShowCallStrategyModal] = useState(false);

    const [selectedAgentIds, setSelectedAgentIds] = useState([]);
    const [startTime, setStartTime] = useState("");
    const [endTime, setEndTime] = useState("");

    const [weekDays, setWeekDays] = useState(["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]);
    const [memberWeekDays, setmemberWeekDays] = useState([]);
    const [selectedStrategy, setSelectedStrategy] = useState("ROUNDROBIN RINGING");
    const [sticky, setSticky] = useState(false)
    const [stickyMember, setStickyMember] = useState('off'); // 'normal', 'advance', 'off'
    const [time, setTime] = useState(false);
    const [callStrategy, setCallStratergy] = useState([])
    const [showEditModal, setShowEditModal] = useState(false)
    const [showToastModal, setShowToastModal] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [assignedAgents, setAssignedAgents] = useState([]);
    const [availableAgents, setAvailableAgents] = useState([]);
    const [editData, setEditData] = useState({
        id: '',
        startTime: "",
        endTime: "",
        weekDays: [],
        agent_id: ''
    });
    const [timeScheduledDate, setTimeScheduledDate] = useState({
        startTime: "00:00",
        endTime: "23:59",
        weekDays: [],
    });
    const [timeScheduleWholeDay, setTimeScheduleWholeDay] = useState(true);
    const [editDataWholeDay, setEditDataWholeDay] = useState(false);
    const [showMusicOnHold, setShowMusicOnHold] = useState(false);
    const [priorityError, setPriorityError] = useState(false);
    const [wholeDay, setWholeDay] = useState(false);
    const [groupScheduledId, setGroupScheduledId] = useState('');
    const [selectedWhisper, setSelectedWhisper] = useState('');
    const [selectedMusicHold, setSelectedMusicHold] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [isGroupScheduled, setIsGroupScheduled] = useState(false)
    const [notes, setNotes] = useState([]);
    const [savingMain, setSavingMain] = useState(false);
    const [savingMembers, setSavingMembers] = useState(false);
    const [savingStrategy, setSavingStrategy] = useState(false);
    const [savingSchedule, setSavingSchedule] = useState(false);
    const [savingWhisper, setSavingWhisper] = useState(false);
    const [savingAgentSchedule, setSavingAgentSchedule] = useState(false);

    const [availableInboundNumbers, setAvailableInboundNumbers] = useState([]);
    const [selectedInboundNumberIds, setSelectedInboundNumberIds] = useState([]);
    const [dedicatedInboundNumberId, setDedicatedInboundNumberId] = useState(null);
    const [loadingAvailableNumbers, setLoadingAvailableNumbers] = useState(false);
    const [savingInboundRouting, setSavingInboundRouting] = useState(false);
    const [agentPriorities, setAgentPriorities] = useState({});
    const [addMemberPriorityErrors, setAddMemberPriorityErrors] = useState({});

    const [showCallScriptModal, setShowCallScriptModal] = useState(false);
    const [callScripts, setCallScripts] = useState([]);
    const [selectedCallScriptId, setSelectedCallScriptId] = useState('');
    const [pendingCallScriptId, setPendingCallScriptId] = useState('');
    const [savingCallScript, setSavingCallScript] = useState(false);
    const [loadingCallScripts, setLoadingCallScripts] = useState(false);

    const storedUser = (() => {
        try {
            const raw = Storage.getItem('user');
            return raw ? JSON.parse(raw) : null;
        } catch (e) {
            console.error('Failed to parse user from storage', e);
            return null;
        }
    })();
    const loggedInUserId = storedUser?.id;

    const canAssignInboundNumber =
        storedUser?.role === USER_ROLES.CALL_CENTRE_ADMIN ||
        storedUser?.role === USER_ROLES.SUPERADMIN;


    useEffect(() => {
        getApiCall(`${API_PROMPT_ACTIVE_LIST}/${loggedInUserId}`)
            .then(onPromptsSuccess)
            .catch(onError)
    }, []);


    function onPromptsSuccess(resp) {
        setAudio(resp)
    }

    function onError(err) {
        console.log(err);
    }

    const [audio, setAudio] = useState([]);
    // MOH dropdown source -- only approved (status=1), created by current user.
    const [mohOptions, setMohOptions] = useState([]);
    const [mohLoading, setMohLoading] = useState(false);
    const [mohError, setMohError] = useState('');

    const fetchMohOptions = () => {
        setMohLoading(true);
        setMohError('');
        getApiCall(API_MOH_ACTIVE)
            .then((resp) => {
                const arr = Array.isArray(resp) ? resp : (resp?.data || []);
                // Defensive client-side filter (status === 1, own user, not deleted).
                const filtered = arr.filter(m =>
                    Number(m.moh_status) === 1 &&
                    !m.is_deleted &&
                    Number(m.created_by) === Number(loggedInUserId)
                );
                setMohOptions(filtered);
            })
            .catch((err) => {
                setMohError(typeof err === 'string' ? err : (err?.message || 'Failed to load MOH list'));
                setMohOptions([]);
            })
            .finally(() => setMohLoading(false));
    };

    useEffect(() => {
        if (loggedInUserId) fetchMohOptions();
    }, [loggedInUserId]);



    const handleWholeDayChange = (e) => {
        const isChecked = e.target.checked;
        setWholeDay(isChecked);

        if (isChecked) {
            setStartTime("00:00");
            setEndTime("23:59");
        } else {
            setStartTime("");
            setEndTime("");
        }
    };

    const toMinutes = (timeValue) => {
        if (!timeValue || !String(timeValue).includes(":")) return NaN;
        const [hours, minutes] = String(timeValue).split(":").map(Number);
        if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return NaN;
        return (hours * 60) + minutes;
    };

    function convertTo12Hour(time24) {
        if (!time24) return "";

        let [hours, minutes] = time24.split(":");
        hours = parseInt(hours, 10);

        const ampm = hours >= 12 ? "PM" : "AM";

        hours = hours % 12;
        hours = hours === 0 ? 12 : hours; // 0 -> 12

        return `${hours}:${minutes}${ampm}`;
    }

    const handleStartTimeChange = (e) => {
        const value = e.target.value;
        if (value < timeScheduledDate.startTime || value > timeScheduledDate.endTime) {
            toast.error(`Start time should be within allowed Range (${convertTo12Hour(timeScheduledDate.startTime)} to ${convertTo12Hour(timeScheduledDate.endTime)})`);
            return;
        }

        if (!wholeDay) {
            setStartTime(e.target.value);
        }
    };

    const handleEndTimeChange = (e) => {
        const value = e.target.value;
        if (value < timeScheduledDate.startTime || value > timeScheduledDate.endTime) {
            toast.error(`End time should be within allowed range (${convertTo12Hour(startTime)} to ${convertTo12Hour(timeScheduledDate.endTime)})`);
            return;
        }

        if (value < startTime) {
            toast.error("End time cannot be less than start time");
            return;
        }
        if (!wholeDay) {
            setEndTime(e.target.value);
        }
    };


    const showToast = (message) => {
        setToastMessage(message);
        setShowToastModal(true);

        // Hide modal automatically after 3 seconds
        setTimeout(() => {
            setShowToastModal(false);
        }, 3000);
    };

    const handleAddMembersClick = () => {
        setShowAddMembersModal(true);
    };

    const handleModalClose = () => {
        setShowAddMembersModal(false);
    };

    const handleTimeScheduleClick = () => {
        setShowTimeScheduleModal(true);
    };


    const handleTimeScheduleClose = () => {
        setTime(true)
        setShowTimeScheduleModal(false);
    };

    const handleWhisperClick = () => {
        setShowWhisperModal(true);
    };

    const handleWhisperClose = () => {
        setShowWhisperModal(false);
    };

    const handleCallStrategyClick = () => {
        setShowCallStrategyModal(true);
    };

    const handleCallStrategyCloseall = () => {
        setShowCallStrategyModal(false);
    }

    const handleCallStrategyClose = async () => {
        if (savingStrategy) return;

        const finalPayload = {
            strategy: selectedStrategy,
            type: 'strategy'
        }

        try {
            setSavingStrategy(true);
            const response = await postApiCall(API_SINGLE_AGENT_GROUP.replace(':id', groupId), finalPayload);
            if (response) {
                setShowCallStrategyModal(false)
                showToast('Call Stratergy Updated');
                setShowAddMembersModal(false);
            }
        } catch (err) {
            toast.error(err);
        } finally {
            setSavingStrategy(false);
        }
    };

    const handleSaveTimeSchedule = () => {
        if (savingSchedule) return;
        // Validate week days
        if(timeScheduledDate.weekDays==0 || !timeScheduledDate.weekDays || timeScheduledDate.weekDays.length === 0)
        {
            toast.error('Please select atleast one week day')
            return;
        }

        // Validate start and end time when whole day is not selected
        if (!timeScheduleWholeDay) {
            if (!timeScheduledDate.startTime || timeScheduledDate.startTime.trim() === '' || timeScheduledDate.startTime === '--:-- --') {
                toast.error("Please select a start time");
                return;
            }
            if (!timeScheduledDate.endTime || timeScheduledDate.endTime.trim() === '' || timeScheduledDate.endTime === '--:-- --') {
                toast.error("Please select an end time");
                return;
            }
            const startMins = toMinutes(timeScheduledDate.startTime);
            const endMins = toMinutes(timeScheduledDate.endTime);
            if (!Number.isFinite(startMins) || !Number.isFinite(endMins)) {
                toast.error("Invalid time selected");
                return;
            }
            if (timeScheduledDate.weekDays.length === 1 && endMins <= startMins) {
                toast.error("For a single selected day, end time should be greater than start time");
                return;
            }
        }

        const payload = {
            ...timeScheduledDate,
            type: 'time_schedule',
            group_schedule_id: groupScheduledId,
            startTime: timeScheduleWholeDay ? "00:00" : timeScheduledDate.startTime,
            endTime: timeScheduleWholeDay ? "23:59" : timeScheduledDate.endTime,
        }

        setSavingSchedule(true);
        postApiCall(`/v2/agent-group/${groupId}`, payload)
            .then((response) => {
                if (response) {
                    // setGroupScheduledId(response?.agent?.id)
                    setShowTimeScheduleModal(false);
                    showToast('Time Schedule Updated');
                    setIsGroupScheduled(true);
                }
            })
            .catch((err) => {
                toast.error(err);
            })
            .finally(() => {
                setSavingSchedule(false);
            });
    };

    // `/v1/agent-group/${groupId}`

    const getAgentGroupData = async () => {
        if (!groupId) {
            setIsLoading(false);
            return;
        }
        try {
            setIsLoading(true);
            const response = await getApiCall(API_SINGLE_AGENT_GROUP.replace(':id', groupId));
            if (response) {
                setTimeScheduledDate({
                    startTime: response?.group_schedule?.start_time || '',
                    endTime: response?.group_schedule?.end_time || '',
                    weekDays: response?.group_schedule?.week_days || []
                });
                if (response?.group_schedule?.start_time) {
                    setIsGroupScheduled(true)
                }
                if (response?.group_schedule?.start_time == "00:00" && response?.group_schedule?.end_time == "23:59") {
                   setTimeScheduleWholeDay(true)
                } else {
                    setTimeScheduleWholeDay(false)
                }
                setSelectedStrategy(response?.strategy || "ROUNDROBIN RINGING")
                setSelectedWhisper(response?.whisper_id || '')
                // Convert sticky to boolean (handle both true/false and 1/0 from database)
                setSticky(response?.sticky === true || response?.sticky === 1)
                setSelectedMusicHold(response?.music_on_hold || null)
                setStickyMember(response?.sticky_member || 'off') // Load sticky member setting
                setSelectedCallScriptId(
                    response?.script_id != null && response?.script_id !== ''
                        ? String(response.script_id)
                        : ''
                );
                setAgentGroup(response);
                setGroupScheduledId(response.group_schedule_id)
                setIsDataLoaded(true);
            } else {
                toast.error("Failed to fetch assigned agents.");
                setIsDataLoaded(true);
            }
        } catch (error) {
            console.error("Error fetching assigned agents:", error);
            toast.error("Error fetching assigned agents.");
            setIsDataLoaded(true);
        } finally {
            setIsLoading(false);
        }
    };



    const handleEditClick = (agent) => {
        setEditData({
            agent_id: agent?.agent_id || agent?.agent_id,
            id: agent.schedule?.id || agent.schedule?.id,
            startTime: agent.schedule?.start_time || "00:00",
            endTime: agent.schedule?.end_time || "23:59",
            weekDays: agent.schedule?.week_days || ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
           priority: agent?.priority !== undefined && agent?.priority !== null && agent?.priority !== '10' 
        ? String(agent?.priority) 
      : '10'
        });
        if (agent.schedule?.start_time === "00:00" && agent.schedule?.end_time === "23:59") {
            setEditDataWholeDay(true)
        } else {
            setEditDataWholeDay(false)
        }
        setPriorityError(false);
        setShowEditModal(true);
    };


    // `/v1/agent-group/${groupId}/assigned-agents`

    const fetchAgentData = async () => {
        if (!groupId) return;
        try {
            const [agentsResponse, assignedAgentsResponse] = await Promise.all([
                getApiCall(API_AGENTS_LIST),
                getApiCall(API_AGENT_GROUP_ASSIGNED_AGENTS.replace(':id', groupId))
            ]);

            if (agentsResponse && assignedAgentsResponse) {

                // Get a set of assigned agent IDs
                const assignedAgentIds = new Set(
                    assignedAgentsResponse.map((assigned) => assigned.agent_id)
                );

                // Filter and get full agent objects that are not already assigned
                const available = agentsResponse.filter(
                    (agent) => (!assignedAgentIds.has(agent.id) && agent?.schedule_id === null)
                );

                setAvailableAgents(available);
                setAssignedAgents(assignedAgentsResponse);
            }

        } catch (error) {
            console.error("Error fetching agents:", error);
            toast.error("Failed to fetch agent data.");
        }
    };



    const handleAddMembersSave = async () => {
        if (savingMembers) return;

        if(memberWeekDays==0)
        {
          toast.error('Please select atleat one week day');
          return;
        }

        if (!wholeDay) {
            const startMins = toMinutes(startTime);
            const endMins = toMinutes(endTime);
            if (!Number.isFinite(startMins) || !Number.isFinite(endMins)) {
                toast.error("Invalid time selected");
                return;
            }
            if (memberWeekDays.length === 1 && endMins <= startMins) {
                toast.error("For a single selected day, end time should be greater than start time");
                return;
            }
        }
        const selectedAgents = availableAgents
            .filter((agent) => selectedAgentIds.includes(agent.id))
            .map((agent) => ({
                ...agent,
                startTime,
                endTime,
                is_allocated: 1, // Mark agent as allocated
                priority: (() => {
                const val = agentPriorities[String(agent.id)];
                const num = parseInt(val, 10);
                return isNaN(num) ? 10 : num;
              })(),
            }));

          if (selectedAgents.length === 0) {
               toast.error("Please select at least one agent before adding a member.");
            return;
            }

            
    const errors = {};
    let hasPriorityError = false;
    selectedAgentIds.forEach((id) => {
    const val = agentPriorities[String(id)];
        if (val === undefined || val === '') {
        setAgentPriorities(prev => ({ ...prev, [String(id)]: '10' }));
        return; 
    }

       const num = parseInt(val, 10);
        if (val === undefined || val === '' || isNaN(num) || num < 0 || num > 10) {
        errors[String(id)] = true;
        hasPriorityError = true;
    } else if (addMemberPriorityErrors[String(id)] === 'duplicate') {
        errors[String(id)] = 'duplicate';
        hasPriorityError = true;
}
});

 if (hasPriorityError) {
        setAddMemberPriorityErrors(errors);
        toast.error("Priority (0–10) is required for all selected agents");
        return;
    }

    const manuallyFilledIds = selectedAgentIds.filter(id => {
    const val = agentPriorities[String(id)];
    return val !== undefined && val !== '';
    });

    const manualPriorities = manuallyFilledIds.map(id =>
    parseInt(agentPriorities[String(id)], 10)
    );
    const uniqueManual = new Set(manualPriorities);
    if (uniqueManual.size !== manualPriorities.length) {
    toast.error("Each agent must have a unique priority.");
    return;
    }

        const AddmemberPayload = {
            type: 'add_member',
            agent_id: selectedAgents.map((data) => data.id),
            member_count: selectedAgents?.length,
            priorities: selectedAgents.reduce((acc, a) => {
            const val = agentPriorities[String(a.id)];
            const num = parseInt(val, 10);
            acc[a.id] = isNaN(num) ? 10 : num; 
            return acc;
      }, {}),
            memberSchedulePayload: {
                week_days: memberWeekDays,
                start_time: startTime,
                end_time: endTime,
            }
        };

        try {
            setSavingMembers(true);
            // Step 1: Update agents in the group
            const [addMembersResponse] = await Promise.all([
                postApiCall(API_SINGLE_AGENT_GROUP.replace(':id', groupId), AddmemberPayload),
            ]);
            if (addMembersResponse) {
                showToast('Members added, schedules updated, and allocation updated successfully');

                setAssignedAgents((prev) => [...prev, ...selectedAgents]);
                setAvailableAgents((prev) =>
                    prev.filter((agent) => !selectedAgentIds.includes(agent.id))
                );

               setSelectedAgentIds([]);
                setAgentPriorities({});       
            setAddMemberPriorityErrors({});
            setShowAddMembersModal(false);
                await fetchAgentData();
            } else {
                toast.error("Failed to complete all member actions. Please try again.");
            }
        } catch (error) {
            console.error("Error in handleAddMembersSave:", error);
            toast.error(`Error: ${error.message || 'Something went wrong'}`);
        } finally {
            setSavingMembers(false);
        }
    };





    const handleSticky = (value) => {
        // Only update state, don't save immediately
        setSticky(value);
    }


    const handleMusicOnHold = (value) => {
        // Only update state, don't save immediately
        if (value) {
            setShowMusicOnHold(true)
            // Don't set selectedMusicHold here, let user select from modal
        } else {
            setSelectedMusicHold(null)
            setShowMusicOnHold(false)
        }
    }

    const handleStickyMemberChange = (value) => {
        // Only update state, don't save immediately
        setStickyMember(value);
    }

    const fetchCallStratergies = () => {

        getApiCall(API_CALL_STRATEGIES_MASTER_LIST).then((data) => {
            setCallStratergy(data);
        }).catch((err) => {
            toast.error("Error fetching call stratergies")
        })
    }

    const fetchCallScripts = async () => {
        setLoadingCallScripts(true);
        try {
            const resp = await getApiCall(API_CALL_SCRIPT_LIST);
            const list = Array.isArray(resp) ? resp : resp?.data ?? [];
            const filtered = list.filter(
                (s) =>
                    s && s.created_by
            );
            setCallScripts(filtered);
        } catch (err) {
            console.error('Error fetching call scripts:', err);
            setCallScripts([]);
        } finally {
            setLoadingCallScripts(false);
        }
    };

    const handleCallScriptClick = () => {
        setPendingCallScriptId(selectedCallScriptId || '');
        setShowCallScriptModal(true);
    };

    const handleCallScriptClose = () => {
        if (savingCallScript) return;
        setShowCallScriptModal(false);
        setPendingCallScriptId('');
    };

    const handleCallScriptSave = async () => {
        if (savingCallScript) return;

        const trimmed =
            pendingCallScriptId === '' || pendingCallScriptId == null
                ? null
                : String(pendingCallScriptId);

        if (trimmed !== null) {
            const exists = callScripts.some(
                (s) => String(s.id) === trimmed
            );
            if (!exists) {
                toast.error('Selected call script is not valid.');
                return;
            }
        }

        const finalPayload = {
            script_id: trimmed === null ? null : Number(trimmed),
        };

        try {
            setSavingCallScript(true);
            const response = await postApiCall(
                API_SINGLE_AGENT_GROUP.replace(':id', groupId),
                finalPayload
            );
            if (response) {
                setSelectedCallScriptId(trimmed === null ? '' : trimmed);
                showToast(
                    trimmed === null
                        ? 'Call Script removed'
                        : 'Call Script updated'
                );
                setShowCallScriptModal(false);
                await getAgentGroupData();
            }
        } catch (err) {
            toast.error(
                typeof err === 'string'
                    ? err
                    : err?.message || 'Failed to update Call Script'
            );
        } finally {
            setSavingCallScript(false);
        }
    };

    const handleCallScriptRemove = async () => {
        if (savingCallScript) return;
        if (!selectedCallScriptId) {
            toast.info('No Call Script attached');
            return;
        }
        setPendingCallScriptId('');
        try {
            setSavingCallScript(true);
            const response = await postApiCall(
                API_SINGLE_AGENT_GROUP.replace(':id', groupId),
                { script_id: null }
            );
            if (response) {
                setSelectedCallScriptId('');
                showToast('Call Script removed');
                setShowCallScriptModal(false);
                await getAgentGroupData();
            }
        } catch (err) {
            toast.error(
                typeof err === 'string'
                    ? err
                    : err?.message || 'Failed to remove Call Script'
            );
        } finally {
            setSavingCallScript(false);
        }
    };

    const loadAvailableInboundNumbers = async () => {
        if (!groupId || !canAssignInboundNumber) return;
        setLoadingAvailableNumbers(true);
        try {
            const list = await getApiCall(
                API_AGENT_GROUP_AVAILABLE_INBOUND_NUMBERS.replace(':id', groupId)
            );
            setAvailableInboundNumbers(Array.isArray(list) ? list : []);
        } catch (e) {
            console.error(e);
            setAvailableInboundNumbers([]);
        } finally {
            setLoadingAvailableNumbers(false);
        }
    };

    const handleInboundNumberSelect = (values) => {
        const ids = (values || [])
            .map((v) => Number(v))
            .filter((v) => Number.isFinite(v));
        setSelectedInboundNumberIds((prev) => {
            // Preserve the original selection order so first-selected stays default.
            const kept = prev.filter((id) => ids.includes(id));
            const appended = ids.filter((id) => !kept.includes(id));
            return [...kept, ...appended];
        });
        setDedicatedInboundNumberId((prev) =>
            prev != null && ids.includes(prev) ? prev : null
        );
    };

    const handleSaveInboundNumberAssignment = async () => {
        if (!agentGroup?.group_name || !groupId || savingInboundRouting) {
            return;
        }
        setSavingInboundRouting(true);
        try {
            await postApiCall(
                API_AGENT_GROUP_CLI_ALLOCATIONS_SYNC.replace(':id', groupId),
                {
                    numberIds: selectedInboundNumberIds,
                    defaultNumberId: selectedInboundNumberIds?.[0] || null,
                    dedicatedNumberIds:
                        dedicatedInboundNumberId != null
                            ? [dedicatedInboundNumberId]
                            : [],
                }
            );
            toast.success('Inbound numbers updated');
            await loadAvailableInboundNumbers();
        } catch (error) {
            toast.error(
                typeof error === 'string' ? error : error?.message || 'Failed to save inbound numbers'
            );
        } finally {
            setSavingInboundRouting(false);
        }
    };

    useEffect(() => {
        if (!groupId) return;
        const fetchData = async () => {
            await fetchAgentData();
            fetchCallStratergies();
            fetchCallScripts();
            await getAgentGroupData();
        };

        fetchData();
        fetchAndSetFlashMessage(
        msg => msg.module_name === MODULE_ACL.CALL_GROUP && msg.action === FLASH_MESSAGE_ACTION_OBJECT.EDIT && msg.type === 'Note',
        setNotes
        );
    }, [groupId]);

    useEffect(() => {
        setAvailableInboundNumbers([]);
        setSelectedInboundNumberIds([]);
        setDedicatedInboundNumberId(null);
        if (!groupId || !canAssignInboundNumber) {
            return;
        }
        loadAvailableInboundNumbers();
    }, [groupId, canAssignInboundNumber]);

    useEffect(() => {
        if (!availableInboundNumbers.length || !groupId) {
            return;
        }
        const inGroupCli = availableInboundNumbers.filter((n) => {
            if (n.cli_target_type === 'QUEUE' && String(n.cli_target_id) === String(groupId)) {
                return true;
            }
            return (
                n.cli_target_type == null &&
                n.routing_type === 'QUEUE' &&
                Number(n.routing_id) === Number(groupId)
            );
        });
        if (inGroupCli.length) {
            setSelectedInboundNumberIds(
                inGroupCli
                    .map((b) => Number(b.id))
                    .filter((id) => Number.isFinite(id))
            );
            const dedicatedMatch = inGroupCli.find(
                (n) =>
                    n.inbound_routing_type === 'QUEUE' &&
                    String(n.inbound_routing_id) === String(groupId)
            );
            setDedicatedInboundNumberId(
                dedicatedMatch && Number.isFinite(Number(dedicatedMatch.id))
                    ? Number(dedicatedMatch.id)
                    : null
            );
        } else {
            setSelectedInboundNumberIds([]);
            setDedicatedInboundNumberId(null);
        }
    }, [availableInboundNumbers, groupId]);

    const handleRemoveAgent = async (agentId) => {
        try {
            await postApiCall(`/v2/agent-group/remove-agent/${groupId}`, { agent_id: agentId });
            showToast('Agent removed successfully');
            await fetchAgentData()
        } catch (error) {
            toast.error('Failed to remove agent');
        }
    };

    const handleSaveAgentEdit = async () => {
        if (savingAgentSchedule) return;
        // Validate priority is mandatory
        if (!editData.priority || editData.priority === '' || editData.priority === null || editData.priority === undefined) {
            setPriorityError(true);
            toast.error("Priority is required and must be a number between 0 and 10");
            return;
        }

        // Validate priority range
        const priorityNum = parseInt(editData.priority);
        if (isNaN(priorityNum) || priorityNum < 0 || priorityNum > 10) {
            setPriorityError(true);
            toast.error("Priority must be a number between 0 and 10");
            return;
        }

        const finalPayload = {
            agent_id: editData.agent_id,
            id: editData.id,
            start_time: editData.startTime,
            end_time: editData.endTime,
            week_days: editData.weekDays,
            priority: editData.priority
        };


        if(finalPayload.week_days==0)
        {
            toast.error("Please select atleast one week day");
            return;
        }

        if (!(editData.startTime === "00:00" && editData.endTime === "23:59")) {
            const startMins = toMinutes(editData.startTime);
            const endMins = toMinutes(editData.endTime);
            if (!Number.isFinite(startMins) || !Number.isFinite(endMins)) {
                toast.error("Invalid time selected");
                return;
            }
            if (editData.weekDays.length === 1 && endMins <= startMins) {
                toast.error("For a single selected day, end time should be greater than start time");
                return;
            }
        }
        
        try {
            setSavingAgentSchedule(true);
            const response = await postApiCall(`/v2/agent-group/schedule/${groupId}`, finalPayload);
            if (response) {
                setShowEditModal(false);
                await fetchAgentData()
            }
        } catch (err) {
            console.error('Error updating agent time schedule:', err);
            toast.error('Failed to update agent time schedule');
        } finally {
            setSavingAgentSchedule(false);
        }

        // try {
        //     await postApiCall(`/v2/agent-group/schedule/${groupId}`, finalPayload);
        //     showToast('Agent time schedule updated successfully');
        //     setShowEditModal(false);

        //     setAssignedAgents((prev) =>
        //         prev.map((agent) =>
        //             agent.id === editData.id
        //                 ? {
        //                       ...agent,
        //                       time_schedule: {
        //                           start_time: formattedStartTime,
        //                           end_time: formattedEndTime,
        //                           week_days: editData.weekDays,
        //                       },
        //                   }
        //                 : agent
        //         )
        //     );
        // } catch (error) {
        //     console.error('Error updating agent time schedule:', error);
        //     toast.error('Failed to update agent time schedule');
        // }
    };

    const handlesave = async () => {
        if (savingMain) return;

        // Frontend validation: if MOH is chosen, ensure it's in the approved+own list.
        let mohIdToSend = null;
        if (selectedMusicHold !== null && selectedMusicHold !== undefined && selectedMusicHold !== '') {
            const mohId = Number(selectedMusicHold);
            if (!Number.isInteger(mohId) || mohId <= 0) {
                toast.error('Invalid MOH selected');
                return;
            }
            const exists = mohOptions.some(m => Number(m.id) === mohId);
            if (!exists) {
                toast.error('Selected MOH is not approved or not owned by you. Please pick from the list.');
                return;
            }
            mohIdToSend = mohId;
        }

        try {
            setSavingMain(true);
            const finalPayload = {
                sticky: sticky,
                sticky_member: stickyMember,
                music_on_hold: mohIdToSend
            };

            await postApiCall(API_SINGLE_AGENT_GROUP.replace(':id', groupId), finalPayload);
            showToast('Agent Group Settings Updated Successfully');
            // Optionally refresh the data to show updated values
            await getAgentGroupData();
        } catch (error) {
            console.error("Error saving settings:", error);
            toast.error(error || "Failed to save settings");
        } finally {
            setSavingMain(false);
        }
    };

    const handleWhisperSave = async () => {
        if (savingWhisper) return;
        // Convert empty string to null for backend
        const whisperId = selectedWhisper && selectedWhisper !== '' ? selectedWhisper : null;

        const finalPayload = {
            whisper_id: whisperId,
        }

        try {
            setSavingWhisper(true);
            const response = await postApiCall(API_SINGLE_AGENT_GROUP.replace(':id', groupId), finalPayload);
            if (response) {
                showToast('Whisper Updated');
                setShowWhisperModal(false);
                // Refresh data to show updated whisper
                getAgentGroupData();
            }
        } catch (err) {
            toast.error(err)
        } finally {
            setSavingWhisper(false);
        }
    };

    const handleMusicHoldSave = () => {
        // Just close the modal, don't save immediately
        // The selectedMusicHold state will be saved when main Save button is clicked
        setShowMusicOnHold(false);
    };

    // Show loader while data is being fetched
    if (isLoading || !isDataLoaded) {
        return (
            <div style={{ marginTop: '20px' }}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <Card.Body>
                                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                                    <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }


    const generateTimeOptions = (startRange, endRange, selectedStart = null) => {
        const times = [];

        for (let h = 0; h < 24; h++) {
            for (let m = 0; m < 60; m += 15) {
                const time = `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;

                let isDisabled =
                    time < startRange ||
                    time > endRange;

                // extra rule for end time
                if (selectedStart && time < selectedStart) {
                    isDisabled = true;
                }

                times.push({ time, isDisabled });
            }
        }

        return times;
    };

    return (
        <div style={{ marginTop: '20px' }}>
            {/* <Toaster /> */}
            <Row>
                <Col sm="12"> 
                    <Card>
                        <Card.Header>
                            <h4>Group Settings</h4>
                        </Card.Header>
                        <Card.Body>
                            <p>You can configure the IVR settings according to the created call group from adding members to time schedules and call strategies.</p>

                            {canAssignInboundNumber && groupId ? (
                                <Row className="mb-4 mt-4 g-4 align-items-start">
                                    <Col md={12} lg={7} className="pe-lg-3">
                                        <Form.Label className="fw-semibold mb-2 d-block">
                                            Inbound numbers (route to this call group)
                                        </Form.Label>
                                        <MultiSelect
                                            value={selectedInboundNumberIds}
                                            options={availableInboundNumbers.map((n) => ({
                                                label: `${String(n.actual_number)} (CLI)${Number(selectedInboundNumberIds?.[0]) === Number(n.id) ? ' — default' : ''}`,
                                                value: Number(n.id),
                                            }))}
                                            onChange={(e) =>
                                                handleInboundNumberSelect(e.value)
                                            }
                                            disabled={
                                                loadingAvailableNumbers || savingInboundRouting
                                            }
                                            placeholder="Select numbers"
                                            display="chip"
                                            filter
                                            className="w-100"
                                            style={{ minHeight: '58px', fontSize: '14px' }}
                                            panelStyle={{ maxHeight: '280px' }}
                                            maxSelectedLabels={20}
                                        />
                                    </Col>
                                    <Col md={12} lg={5} className="ps-lg-4">
                                        <div className="group-cli-dedicated-panel h-100 rounded-3 p-3">
                                            <Form.Group className="mb-0">
                                                <Form.Label className="fw-semibold mb-3 d-block">
                                                    Dedicated CLI (one number)
                                                </Form.Label>
                                                <div className="group-cli-radio-list rounded-3 p-3 mb-3">
                                                    <Form.Check
                                                        type="radio"
                                                        id="group-dedicated-cli-none"
                                                        name="groupDedicatedCli"
                                                        label="None"
                                                        checked={dedicatedInboundNumberId === null}
                                                        onChange={() => setDedicatedInboundNumberId(null)}
                                                        disabled={
                                                            savingInboundRouting ||
                                                            !selectedInboundNumberIds?.length
                                                        }
                                                        className="mb-3"
                                                    />
                                                    {selectedInboundNumberIds.map((nid) => {
                                                        const row = availableInboundNumbers.find(
                                                            (n) => Number(n.id) === Number(nid)
                                                        );
                                                        if (!row) return null;
                                                        return (
                                                            <Form.Check
                                                                key={`grp-ded-${nid}`}
                                                                type="radio"
                                                                id={`grp-dedicated-cli-${nid}`}
                                                                name="groupDedicatedCli"
                                                                label={`${row.actual_number} (CLI)`}
                                                                checked={dedicatedInboundNumberId === Number(nid)}
                                                                onChange={() =>
                                                                    setDedicatedInboundNumberId(Number(nid))
                                                                }
                                                                disabled={savingInboundRouting}
                                                                className="mb-2"
                                                            />
                                                        );
                                                    })}
                                                </div>
                                                <div className="group-cli-info-box d-flex align-items-start gap-3 p-3 rounded-3 mb-4">
                                                    <FiInfo
                                                        size={20}
                                                        className="group-cli-info-box__icon flex-shrink-0"
                                                        aria-hidden
                                                    />
                                                    <span>
                                                        For a dedicated CLI, open <strong>Numbers</strong> → inbound routing for that number and set the <strong>time schedule</strong> as needed.
                                                    </span>
                                                </div>
                                                <Button
                                                    variant="primary"
                                                    className="px-4"
                                                    disabled={savingInboundRouting}
                                                    onClick={handleSaveInboundNumberAssignment}
                                                >
                                                    {savingInboundRouting
                                                        ? 'Saving…'
                                                        : 'Save inbound numbers'}
                                                </Button>
                                            </Form.Group>
                                        </div>
                                    </Col>
                                </Row>
                            ) : null}

                            <div style={{ display: "flex", justifyContent: "flex-start", marginTop: "40px", gap: "60px", flexWrap: "wrap", paddingLeft: "20px", paddingRight: "20px" }}>

                                <button
                                    onClick={handleAddMembersClick}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '8px',
                                        position: 'relative',
                                        padding: '12px 20px',
                                        minWidth: '146px',
                                        minHeight: '49px',
                                        backgroundColor: '#ffffff',
                                        border: '2px solid #28a745',
                                        borderRadius: '8px',
                                        color: '#333333',
                                        fontWeight: '500',
                                        fontSize: '12px',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease',
                                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.boxShadow = '0 4px 8px rgba(40, 167, 69, 0.2)';
                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                        e.currentTarget.style.borderColor = '#1e7e34';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.borderColor = '#28a745';
                                    }}
                                >
                                    <span>+ Add Members</span>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip id="add-members-tooltip">
                                                Include your member in this group to assign workflows specifically according to time schedules and call strategies.
                                            </Tooltip>
                                        }
                                    >
                                        <div
                                            style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '20px',
                                                height: '20px',
                                                borderRadius: '50%',
                                                backgroundColor: '#ffffff',
                                                border: '1px solid #28a745',
                                                transition: 'all 0.2s ease',
                                                cursor: 'pointer',
                                                marginLeft: 'auto'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = 'rgba(40, 167, 69, 0.1)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = '#ffffff';
                                            }}
                                        >
                                            <FiInfo
                                                style={{
                                                    color: '#28a745',
                                                    fontSize: '12px'
                                                }}
                                            />
                                        </div>
                                    </OverlayTrigger>
                                </button>

                                <button
                                    onClick={handleTimeScheduleClick}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '8px',
                                        position: 'relative',
                                        padding: '12px 20px',
                                        minWidth: '146px',
                                        minHeight: '49px',
                                        backgroundColor: '#ffffff',
                                        border: '2px solid #007bff',
                                        borderRadius: '8px',
                                        color: '#333333',
                                        fontWeight: '500',
                                        fontSize: '12px',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease',
                                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.boxShadow = '0 4px 8px rgba(0, 123, 255, 0.2)';
                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                        e.currentTarget.style.borderColor = '#0056b3';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.borderColor = '#007bff';
                                    }}
                                >
                                    <span>+ Time Schedule</span>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip id="time-schedule-tooltip">
                                                Account owner can configure when calls are routed to available members based on provided scheduled business hours.
                                            </Tooltip>
                                        }
                                    >
                                        <div
                                            style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '20px',
                                                height: '20px',
                                                borderRadius: '50%',
                                                backgroundColor: '#ffffff',
                                                border: '1px solid #007bff',
                                                transition: 'all 0.2s ease',
                                                cursor: 'pointer',
                                                marginLeft: 'auto'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = 'rgba(0, 123, 255, 0.1)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = '#ffffff';
                                            }}
                                        >
                                            <FiInfo
                                                style={{
                                                    color: '#007bff',
                                                    fontSize: '12px'
                                                }}
                                            />
                                        </div>
                                    </OverlayTrigger>
                                </button>

                                <button
                                    onClick={handleCallStrategyClick}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '8px',
                                        position: 'relative',
                                        padding: '12px 20px',
                                        minWidth: '146px',
                                        minHeight: '49px',
                                        backgroundColor: '#ffffff',
                                        border: '2px solid #6f42c1',
                                        borderRadius: '8px',
                                        color: '#333333',
                                        fontWeight: '500',
                                        fontSize: '12px',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease',
                                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.boxShadow = '0 4px 8px rgba(111, 66, 193, 0.2)';
                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                        e.currentTarget.style.borderColor = '#5a32a3';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.borderColor = '#6f42c1';
                                    }}
                                >
                                    <span>+ Call Strategy</span>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip id="call-strategy-tooltip">
                                                It provides a method to handle call flows for members with several extensions using a variety of routing strategies.
                                            </Tooltip>
                                        }
                                    >
                                        <div
                                            style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '20px',
                                                height: '20px',
                                                borderRadius: '50%',
                                                backgroundColor: '#ffffff',
                                                border: '1px solid #6f42c1',
                                                transition: 'all 0.2s ease',
                                                cursor: 'pointer',
                                                marginLeft: 'auto'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = 'rgba(111, 66, 193, 0.1)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = '#ffffff';
                                            }}
                                        >
                                            <FiInfo
                                                style={{
                                                    color: '#6f42c1',
                                                    fontSize: '12px'
                                                }}
                                            />
                                        </div>
                                    </OverlayTrigger>
                                </button>

                                <button
                                    onClick={handleWhisperClick}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '8px',
                                        position: 'relative',
                                        padding: '12px 20px',
                                        minWidth: '146px',
                                        minHeight: '49px',
                                        backgroundColor: '#ffffff',
                                        border: '2px solid #fd7e14',
                                        borderRadius: '8px',
                                        color: '#333333',
                                        fontWeight: '500',
                                        fontSize: '12px',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease',
                                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.boxShadow = '0 4px 8px rgba(253, 126, 20, 0.2)';
                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                        e.currentTarget.style.borderColor = '#dc6502';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.borderColor = '#fd7e14';
                                    }}
                                >
                                    <span>+ Agent Whisper</span>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip id="agent-whisper-tooltip">
                                                Agent Whisper voice messages so that your team can hear this voice prompt first before connecting with the customer.
                                            </Tooltip>
                                        }
                                    >
                                        <div
                                            style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '20px',
                                                height: '20px',
                                                borderRadius: '50%',
                                                backgroundColor: '#ffffff',
                                                border: '1px solid #fd7e14',
                                                transition: 'all 0.2s ease',
                                                cursor: 'pointer',
                                                marginLeft: 'auto'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = 'rgba(253, 126, 20, 0.1)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = '#ffffff';
                                            }}
                                        >
                                            <FiInfo
                                                style={{
                                                    color: '#fd7e14',
                                                    fontSize: '12px'
                                                }}
                                            />
                                        </div>
                                    </OverlayTrigger>
                                </button>

                                <button
                                    onClick={handleCallScriptClick}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '8px',
                                        position: 'relative',
                                        padding: '12px 20px',
                                        minWidth: '146px',
                                        minHeight: '49px',
                                        backgroundColor: '#ffffff',
                                        border: '2px solid #17a2b8',
                                        borderRadius: '8px',
                                        color: '#333333',
                                        fontWeight: '500',
                                        fontSize: '12px',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease',
                                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.boxShadow = '0 4px 8px rgba(23, 162, 184, 0.2)';
                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                        e.currentTarget.style.borderColor = '#117a8b';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.borderColor = '#17a2b8';
                                    }}
                                >
                                    <span>
                                        {selectedCallScriptId ? 'Edit Call Script' : '+ Call Script'}
                                    </span>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip id="call-script-tooltip">
                                                Attach an optional Call Script (your own scripts only) that agents can reference for this call group.
                                            </Tooltip>
                                        }
                                    >
                                        <div
                                            style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '20px',
                                                height: '20px',
                                                borderRadius: '50%',
                                                backgroundColor: '#ffffff',
                                                border: '1px solid #17a2b8',
                                                transition: 'all 0.2s ease',
                                                cursor: 'pointer',
                                                marginLeft: 'auto'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = 'rgba(23, 162, 184, 0.1)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = '#ffffff';
                                            }}
                                        >
                                            <FiInfo
                                                style={{
                                                    color: '#17a2b8',
                                                    fontSize: '12px'
                                                }}
                                            />
                                        </div>
                                    </OverlayTrigger>
                                </button>
                            </div>

                            {selectedCallScriptId ? (() => {
                                const attached = callScripts.find(
                                    (s) => String(s.id) === String(selectedCallScriptId)
                                );
                                return (
                                    <div
                                        className="mt-3"
                                        style={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: '10px',
                                            padding: '8px 12px',
                                            // background: '#e8f7fa',
                                            border: '1px solid #b3e5ec2b',
                                            borderRadius: '8px',
                                            marginLeft: '20px',
                                            fontSize: '13px',
                                            // color: '#0c5460'
                                        }}
                                    >
                                        <strong>Attached Call Script:</strong>
                                        <span>
                                            {attached?.title || `#${selectedCallScriptId}`}
                                        </span>
                                        <button
                                            type="button"
                                            onClick={handleCallScriptClick}
                                            disabled={savingCallScript}
                                            style={{
                                                background: 'transparent',
                                                border: '1px solid #17a2b8',
                                                color: '#0c5460',
                                                borderRadius: '4px',
                                                padding: '2px 8px',
                                                fontSize: '12px',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            Change
                                        </button>
                                        <button
                                            type="button"
                                            onClick={handleCallScriptRemove}
                                            disabled={savingCallScript}
                                            style={{
                                                background: 'transparent',
                                                border: '1px solid #dc3545',
                                                color: '#a71d2a',
                                                borderRadius: '4px',
                                                padding: '2px 8px',
                                                fontSize: '12px',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            {savingCallScript ? 'Removing...' : 'Remove'}
                                        </button>
                                    </div>
                                );
                            })() : null}

                            {/* <div className="mb-3">
                                <div className="d-flex align-items-center">
                                    <button className="btn btn-danger btn-sm me-3" style={{backgroundColor:"#4D869C", border:"none"}} onClick={handleWhisperClick}>+ Configure Whisper</button>
                                    <p className="mb-0">Configure Whisper voice messages so that your team can hear this voice prompt first before connecting with the customer.</p>
                                </div>
                                <hr style={{ border: 'none', height: '1px', backgroundColor: '#dee2e6', margin: '0.5rem 0' }} />
                            </div> */}

                            <div className="mt-4">
                                <p>Only the assigned member will receive calls from the customer. If they don't pick up, the call will get forwarded to the next member automatically:</p>
                                <div className="d-flex align-items-center mb-3">
                                    <div className="form-check me-4">
                                        <input 
                                            type="radio" 
                                            id="normal" 
                                            name="stickyMember" 
                                            className="form-check-input" 
                                            checked={stickyMember === 'normal'}
                                            onChange={() => handleStickyMemberChange('normal')} 
                                        />
                                        <label htmlFor="normal" className="form-check-label">Normal</label>
                                    </div>
                                    <div className="form-check me-4">
                                        <input 
                                            type="radio" 
                                            id="advance" 
                                            name="stickyMember" 
                                            className="form-check-input" 
                                            checked={stickyMember === 'advance'}
                                            onChange={() => handleStickyMemberChange('advance')} 
                                        />
                                        <label htmlFor="advance" className="form-check-label">Advance</label>
                                    </div>
                                    <div className="form-check">
                                        <input 
                                            type="radio" 
                                            id="off" 
                                            name="stickyMember" 
                                            className="form-check-input" 
                                            checked={stickyMember === 'off'}
                                            onChange={() => handleStickyMemberChange('off')} 
                                        />
                                        <label htmlFor="off" className="form-check-label">Off</label>
                                    </div>
                                </div>
                                <hr />
                            </div>

                            <div className="mt-4">
                                <p>Multi IVR Sticky:</p>
                                <div className="d-flex align-items-center mb-3">
                                    <div className="form-check me-4">
                                        <input 
                                            type="radio" 
                                            id="multiIvrOn" 
                                            name="multiIvr" 
                                            className="form-check-input" 
                                            checked={sticky === true}
                                            onChange={() => handleSticky(true)} 
                                        />
                                        <label htmlFor="multiIvrOn" className="form-check-label" >On</label>
                                    </div>
                                    <div className="form-check">
                                        <input 
                                            type="radio" 
                                            id="multiIvrOff" 
                                            name="multiIvr" 
                                            className="form-check-input" 
                                            checked={sticky === false}
                                            onChange={() => handleSticky(false)} 
                                        />
                                        <label htmlFor="multiIvrOff" className="form-check-label">Off</label>
                                    </div>
                                </div>
                                <hr />
                            </div>

                            <div className="mt-4">
                                {/* <p>Multi IVR Sticky:</p> */}
                                <div className="d-flex align-items-center mb-3">
                                    <div className="form-check me-4">
                                        <input 
                                            type="radio" 
                                            id="musicOnHold" 
                                            name="music" 
                                            className="form-check-input" 
                                            checked={selectedMusicHold !== null && selectedMusicHold !== undefined}
                                            onChange={() => handleMusicOnHold(true)} 
                                        />
                                        <label htmlFor="musicOnHold" className="form-check-label" >Music On Hold</label>
                                    </div>
                                    <div className="form-check">
                                        <input 
                                            type="radio" 
                                            id="ringing" 
                                            name="music" 
                                            className="form-check-input" 
                                            checked={selectedMusicHold === null || selectedMusicHold === undefined}
                                            onChange={() => handleMusicOnHold(false)} 
                                        />
                                        <label htmlFor="ringing" className="form-check-label">Ringing</label>
                                    </div>
                                </div>
                                <hr />
                            </div>

                            <div className="mt-4 text-center">
                                <button className="btn btn-danger btncardy" onClick={handlesave} disabled={savingMain}  >
                                    {savingMain ? 'Saving...' : 'Save'}
                                </button>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>



            <div className="mt-4">
                <h5>Assigned Agents</h5>
                <table className="table table-bordered" style={{ marginTop: "20px" }}>
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Team Member Name</th>
                            <th>Mobile Number</th>
                            <th>Agent Status</th>
                            <th>Start Time</th>
                            <th>End Time</th>
                            <th>Prompt</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {assignedAgents.length > 0 ? (
                            assignedAgents.map((agent, index) => (
                                <tr key={agent?.agent_id}>
                                    <td>{index + 1}</td>
                                    <td>{agent?.agent_name}</td>
                                    <td>{agent?.agent_number}</td>
                                    <td>
                                        <div style={{ display: 'flex', gap: '4px', justifyContent: 'start', flexWrap: 'wrap' }}>
                                            {agent?.agentTelephony?.profile?.map((item) => (
                                                <button
                                                    key={item.type}
                                                    className={`btn btn-sm ${item.active_profile ? 'btn-success' : 'btn-danger'
                                                        }`}
                                                    style={{
                                                        padding: '2px 6px',
                                                        fontSize: '10px',
                                                        minWidth: '50px',
                                                    }}
                                                >
                                                    {item.type}
                                                </button>
                                            ))}
                                        </div>
                                    </td>
                                    <td>{agent?.schedule?.start_time || "00:00"}</td>
                                    <td>{agent?.schedule?.end_time || "23:59"}</td>
                                    <td>
                                        {selectedWhisper && selectedWhisper !== '' ? (
                                            audio.find(p => p.id === parseInt(selectedWhisper) || p.id === selectedWhisper)?.prompt_name || 
                                            (typeof selectedWhisper === 'string' ? selectedWhisper : 'N/A')
                                        ) : (
                                            <span style={{ color: '#999', fontStyle: 'italic' }}>No prompt</span>
                                        )}
                                    </td>
                                    <td>
                                        <div className="actions" style={{ display: 'flex', gap: '5px', justifyContent: 'center' }}>
                                            <div onClick={() => handleEditClick(agent)}>
                                                <EditIcon title="Edit" />
                                            </div>
                                            <div>
                                                <DeleteIcon
                                                    title="Delete"
                                                    handleCallback={() => handleRemoveAgent(agent?.agent_id || agent?.agent_id)}
                                                />
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="8" className="text-center">No assigned agents found</td>
                            </tr>
                        )}
                    </tbody>

                </table>
            </div>





            {/* Add Members Modal */}
            <Modal show={showAddMembersModal} onHide={handleModalClose} size="lg" centered>
                <Modal.Header closeButton >
                    <Modal.Title>Add Members in Call Group</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <Row>
                        <Col>
                            <div style={{
                                maxHeight: '300px',
                                overflowY: 'auto',
                                scrollbarWidth: 'thin',
                            }}>
                                <table className="table table-bordered" >
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Team Member Name</th>
                                            <th>Mobile Number</th>
                                            <th>Priority (0-10)</th>
                                            <th>

                                                <input
                                                    type="checkbox"
                                                    // style={{ marginLeft: '10px' }}
                                                    onChange={(e) => {
                                                        if (e.target.checked) {
                                                            // Select all agents
                                                            setSelectedAgentIds(availableAgents.map((agent) => agent.id));
                                                        } else {
                                                            // Deselect all agents
                                                            setSelectedAgentIds([]);
                                                        }
                                                    }}
                                                    checked={selectedAgentIds.length === availableAgents.length && availableAgents.length > 0}
                                                />
                                            </th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {availableAgents.map((agent, index) => (
                                            <tr key={agent.id}>
                                                <td>{index + 1}</td>
                                                <td>{agent.agent_name}</td>
                                                <td>{agent.agent_number}</td>
                                                   <td>
                                                    <div style={{ padding: '4px' }}>
                                                  <input
                                                    type="number"
                                                    min="0"
                                                    max="10"
                                                    placeholder="Default:10"
                                                    value={agentPriorities[String(agent.id)] ?? ''}
                                                    style={{
                                                        width: '100px',
                                                        display: 'block',
                                                        padding: '6px 10px',
                                                        border: addMemberPriorityErrors[agent.id]
                                                            ? '1px solid red'
                                                            : '1px solid #ced4da',
                                                        borderRadius: '4px',
                                                        backgroundColor: addMemberPriorityErrors[agent.id] ? '#fff5f5' : '#fff',
                                                        outline: 'none',
                                                        transition: 'border-color 0.2s'
                                                    }}
                                                  onChange={(e) => {
    const val = e.target.value;
    const num = parseInt(val, 10);

    setAgentPriorities((prev) => {
        const updated = { ...prev, [String(agent.id)]: val };

        const newErrors = {};
        selectedAgentIds.forEach(id => {
            const v = updated[String(id)] ?? '10';
            const n = parseInt(v, 10);
            if (v === '' || isNaN(n) || n < 0 || n > 10) {
                newErrors[String(id)] = true;
                return;
            }
           
     const isDuplicate = selectedAgentIds.some(otherId => {
    if (String(otherId) === String(id)) return false;
    const otherVal = updated[String(otherId)];
    if (otherVal === undefined || otherVal === '') return false;
    return parseInt(otherVal, 10) === n;
});
            if (isDuplicate) newErrors[String(id)] = 'duplicate';
        });

        setAddMemberPriorityErrors(newErrors);
        return updated;
    });
}}
    />
    {addMemberPriorityErrors[agent.id] && (
    <div style={{ color: 'red', fontSize: '10px', marginTop: '2px' }}>
        {addMemberPriorityErrors[agent.id] === 'duplicate'
            ? 'Duplicate priority not allowed'
            : '0–10 required'}
    </div>
)}
                                                </div>
                                            </td>
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedAgentIds.includes(agent.id)}
                                                        onChange={(e) => {
                                                            if (e.target.checked) {
                                                                setSelectedAgentIds((prev) => [...prev, agent.id]);
                                                            } else {
                                                                setSelectedAgentIds((prev) =>
                                                                    prev.filter((id) => id !== agent.id)
                                                                );
                                                
                                                            }
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>


                                </table>
                            </div>

                        </Col>
                    </Row>

                    {isGroupScheduled ? (
                        <Row>
                            <Col>
                                <Form>
                                    {/* Whole Day Checkbox */}
                                    <Form.Check
                                        type="checkbox"
                                        label="Whole Day"
                                        id="wholeDay"
                                        className="mb-3"
                                        checked={wholeDay}
                                        onChange={handleWholeDayChange}
                                        disabled={!(timeScheduledDate?.startTime === "00:00" && timeScheduledDate?.endTime === "23:59")}
                                    />

                                    {/* Start Time */}
                                    <Form.Group className="mb-3">
                                        <Form.Label>Start Time</Form.Label>
                                        <Form.Control
                                            type="time"
                                            value={startTime}
                                            placeholder="00:00:00 AM"
                                            disabled={wholeDay}
                                            onChange={handleStartTimeChange}
                                            min={timeScheduledDate?.startTime}
                                            max={timeScheduledDate?.endTime}
                                            onClick={(e) => e.target.showPicker && e.target.showPicker()}
                                        />
                                    </Form.Group>

                                    {/* End Time */}
                                    <Form.Group className="mb-3">
                                        <Form.Label>End Time</Form.Label>
                                        <Form.Control
                                            type="time"
                                            value={endTime}
                                            placeholder="11:59:59 PM"
                                            disabled={wholeDay}
                                            onChange={handleEndTimeChange}
                                            min={timeScheduledDate?.startTime}
                                            max={timeScheduledDate?.endTime}
                                            onClick={(e) => e.target.showPicker && e.target.showPicker()}
                                        />
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Select Days</Form.Label>
                                        <div>
                                            {timeScheduledDate?.weekDays.map(
                                                (day) => (
                                                    <Form.Check
                                                        inline
                                                        key={day}
                                                        label={day}
                                                        type="checkbox"
                                                        checked={memberWeekDays.includes(day)}
                                                        onChange={(e) => {
                                                            if (e.target.checked) {
                                                                setmemberWeekDays((prev) => [...prev, day]);
                                                            } else {
                                                                setmemberWeekDays((prev) => prev.filter((d) => d !== day));
                                                            }
                                                        }}
                                                    />
                                                )
                                            )}
                                        </div>
                                    </Form.Group>
                                </Form>
                            </Col>
                           <div
                            style={{
                              background: "#FFF8C6",
                              color: "#8B5A2B",
                              padding: "8px 12px",
                              borderRadius: "6px",
                              display: "flex",
                              alignItems: "center",
                              fontSize: "14px",
                              fontWeight: 500,
                            }}
                          >
                            <span>
                              <strong>Note: </strong>Member’s Time Schedule must fall within the Range of Call Group Time Schedule.
                            </span>
                          </div>
                        </Row>
                    ) : (
                          <div
                            style={{
                              background: "#FFF8C6",
                              color: "#8B5A2B",
                              padding: "8px 12px",
                              borderRadius: "6px",
                              display: "flex",
                              alignItems: "center",
                              fontSize: "14px",
                              fontWeight: 500,
                            }}
                          >
                            <span>
                              {/* <strong>Note:</strong> One <strong>Company Licence </strong>is automatically used for the newly created company. */}
                              <strong>Note: </strong>{notes.find(n => Number(n.priority) === 1)?.message ?? ""}
                            </span>
                          </div>
                    )}


                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleModalClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleAddMembersSave} disabled= {!isGroupScheduled || savingMembers}>
                        {savingMembers ? 'Adding...' : 'Add member'}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Call strategy */}
            <Modal show={showCallStrategyModal} onHide={handleCallStrategyCloseall} size="md" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Select Call Strategy</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Select a Strategy:</Form.Label>
                            <div>
                                {callStrategy.map(
                                    (strategy) => (
                                        <Form.Check
                                            style={{ marginTop: "5px" }}
                                            type="radio"
                                            key={strategy.name}
                                            label={strategy.name}
                                            name="callStrategy"
                                            id={strategy.name.replace(/\s+/g, "-").toLowerCase()}
                                            checked={selectedStrategy === strategy.name}
                                            onChange={() => setSelectedStrategy(strategy.name)}
                                        />
                                    )
                                )}
                            </div>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCallStrategyCloseall}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleCallStrategyClose} disabled={savingStrategy}>
                        {savingStrategy ? 'Saving...' : 'Save'}
                    </Button>
                </Modal.Footer>
            </Modal>





            {/* Add Time Schedule Modal */}
            <Modal show={showTimeScheduleModal} onHide={handleTimeScheduleClose} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Time Schedule Setting</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Check
                            type="checkbox"
                            label="Whole Day"
                            id="wholeDay"
                            className="mb-3"
                            checked={timeScheduleWholeDay}
                            onChange={(e) => {
                                setTimeScheduleWholeDay(e.target.checked);
                                setTimeScheduledDate((prev) => ({
                                    ...prev,
                                    startTime: e.target.checked ? "00:00" : "",
                                    endTime: e.target.checked ? "23:59" : "",
                                }));
                            }}
                        />

                        {/* Start Time */}
                        <Form.Group className="mb-3">
                            <Form.Label>Start Time</Form.Label>
                            <Form.Control
                                type="time"
                                value={timeScheduledDate.startTime}
                                placeholder="00:00"
                                disabled={timeScheduleWholeDay}
                                onClick={(e) => e.target.showPicker && e.target.showPicker()}
                                onChange={(e) =>
                                    setTimeScheduledDate((prev) => ({
                                        ...prev,
                                        startTime: e.target.value,
                                    }))
                                }
                            />
                        </Form.Group>

                        {/* End Time */}
                        <Form.Group className="mb-3">
                            <Form.Label>End Time</Form.Label>
                            <Form.Control
                                type="time"
                                value={timeScheduledDate.endTime}
                                placeholder="23:59"
                                disabled={timeScheduleWholeDay}
                                onClick={(e) => e.target.showPicker && e.target.showPicker()}
                                onChange={(e) =>
                                    setTimeScheduledDate((prev) => ({
                                        ...prev,
                                        endTime: e.target.value,
                                    }))
                                }
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Select Days</Form.Label>
                            <div>
                                {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map((day) => (
                                    <Form.Check
                                        inline
                                        key={day}
                                        label={day}
                                        type="checkbox"
                                        checked={timeScheduledDate?.weekDays?.includes(day)}
                                        onChange={(e) => {
                                            setTimeScheduledDate((prev) => ({
                                                ...prev,
                                                weekDays: e.target.checked
                                                    ? [...prev.weekDays, day]
                                                    : prev.weekDays.filter((d) => d !== day),
                                            }));
                                        }}
                                    />
                                ))}
                            </div>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleTimeScheduleClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleSaveTimeSchedule} disabled={savingSchedule}>
                        {savingSchedule ? 'Saving...' : 'Save'}
                    </Button>
                </Modal.Footer>
            </Modal>


            {/* Show whisper model */}
            <Modal show={showWhisperModal} onHide={() => setShowWhisperModal(false)} size="md" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Agent Whisper Prompt</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Select Prompt</Form.Label>
                            <Form.Control
                                as="select"
                                name="audio"
                                value={selectedWhisper}
                                onChange={(e) => setSelectedWhisper(e.target.value)}
                            >
                                <option value="">Select Prompt</option>
                                {audio.map((actionKey) => {
                                    return (
                                        <option key={actionKey.id} value={actionKey.id}>
                                            {actionKey.prompt_name}
                                        </option>
                                    );
                                })}
                            </Form.Control>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleWhisperSave} disabled={savingWhisper}>
                        {savingWhisper ? 'Saving...' : 'Submit'}
                    </Button>
                    <Button variant="secondary" onClick={handleWhisperClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Music on Hold */}
            <Modal show={showMusicOnHold} onHide={() => setShowMusicOnHold(false)} size="md" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Music On Hold</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Select MOH File</Form.Label>
                            <Form.Control
                                as="select"
                                name="moh"
                                value={selectedMusicHold ?? ''}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    setSelectedMusicHold(val === '' ? null : val);
                                }}
                                disabled={mohLoading}
                            >
                                <option value="">
                                    {mohLoading
                                        ? 'Loading MOH list...'
                                        : (mohOptions.length === 0
                                            ? 'No approved MOH available'
                                            : '-- None --')}
                                </option>
                                {mohOptions.map((m) => (
                                    <option key={m.id} value={m.id}>
                                        {m.moh_name}
                                    </option>
                                ))}
                            </Form.Control>
                            {mohError && (
                                <small className="text-danger d-block mt-1">{mohError}</small>
                            )}
                            <div className="d-flex gap-2 mt-2">
                                <Button size="sm" variant="outline-secondary" onClick={fetchMohOptions} disabled={mohLoading}>
                                    {mohLoading ? 'Refreshing...' : 'Refresh List'}
                                </Button>
                                {selectedMusicHold && (
                                    <Button size="sm" variant="outline-danger" onClick={() => setSelectedMusicHold(null)}>
                                        Clear Selection
                                    </Button>
                                )}
                            </div>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="primary"
                        onClick={handleMusicHoldSave}
                        disabled={mohLoading}
                    >
                        Submit
                    </Button>
                    <Button variant="secondary" onClick={() => setShowMusicOnHold(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>


            {/* Call Script Modal */}
            <Modal show={showCallScriptModal} onHide={handleCallScriptClose} size="md" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Select Call Script</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>
                                Call Script <span style={{ color: '#6c757d', fontSize: '12px' }}>(optional)</span>
                            </Form.Label>
                            <Form.Control
                                as="select"
                                name="callScript"
                                value={pendingCallScriptId}
                                disabled={loadingCallScripts || savingCallScript}
                                onChange={(e) => setPendingCallScriptId(e.target.value)}
                            >
                                <option value="">
                                    {loadingCallScripts
                                        ? 'Loading scripts...'
                                        : '-- None (remove script) --'}
                                </option>
                                {callScripts.map((s) => (
                                    <option key={s.id} value={String(s.id)}>
                                        {s.title || `Script #${s.id}`}
                                    </option>
                                ))}
                            </Form.Control>
                            {!loadingCallScripts && callScripts.length === 0 && (
                                <Form.Text className="text-muted">
                                    No call scripts found. Create a script first from the Call Scripts page.
                                </Form.Text>
                            )}
                        </Form.Group>

                        {pendingCallScriptId ? (() => {
                            const preview = callScripts.find(
                                (s) => String(s.id) === String(pendingCallScriptId)
                            );
                            if (!preview) return null;
                            return (
                                <div
                                    style={{
                                        // background: '#f8fafc',
                                        border: '1px solid #e2e8f021',
                                        borderRadius: '6px',
                                        padding: '10px 12px',
                                        fontSize: '13px',
                                        // color: '#334155'
                                    }}
                                >
                                    <div className="mb-1">
                                        <strong>Title: </strong>
                                        {preview.title || '-'}
                                    </div>
                                    {preview.short_description ? (
                                        <div className="mb-1">
                                            <strong>Summary: </strong>
                                            {preview.short_description}
                                        </div>
                                    ) : null}
                                </div>
                            );
                        })() : null}
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    {selectedCallScriptId ? (
                        <Button
                            variant="outline-danger"
                            onClick={handleCallScriptRemove}
                            disabled={savingCallScript}
                        >
                            {savingCallScript ? 'Removing...' : 'Remove Script'}
                        </Button>
                    ) : null}
                    <Button
                        variant="secondary"
                        onClick={handleCallScriptClose}
                        disabled={savingCallScript}
                    >
                        Close
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleCallScriptSave}
                        disabled={
                            savingCallScript ||
                            loadingCallScripts ||
                            String(pendingCallScriptId || '') === String(selectedCallScriptId || '')
                        }
                    >
                        {savingCallScript ? 'Saving...' : 'Save'}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* LOTTIE MODEL FOR TOAST */}
            <Modal show={showToastModal} centered onHide={() => setShowToastModal(false)} size="sm">
                <Modal.Body className="text-center">
                    <h5>{toastMessage}</h5>
                    <LottieAnimation />
                </Modal.Body>
            </Modal>

            {/* EDIT MODAL */}
            <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered >
                <Modal.Header closeButton>
                    <Modal.Title>Edit Member Schedule</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Check
                            type="checkbox"
                            label="Whole Day"   
                            id="wholeDay"
                            className="mb-3"
                            checked={editDataWholeDay}
                            disabled={!(timeScheduledDate?.startTime === "00:00" && timeScheduledDate?.endTime === "23:59")}
                            onChange={(e) => {
                                setEditDataWholeDay(e.target.checked);
                                setEditData((prev) => ({
                                    ...prev,
                                    startTime: e.target.checked ? "00:00" : "",
                                    endTime: e.target.checked ? "23:59" : "",
                                }));
                            }}
                        />

                        {/* Start Time */}
                        <Form.Group className="mb-3">
                            <Form.Label>Start Time</Form.Label>
                            <Form.Control
                                type="time"
                                value={editData.startTime}
                                placeholder="00:00"
                                disabled={editDataWholeDay}
                                min={timeScheduledDate?.startTime}
                                max={timeScheduledDate?.endTime}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (value < timeScheduledDate.startTime || value > timeScheduledDate.endTime) {
                                        toast.error(`Start time should be within allowed Range (${convertTo12Hour(timeScheduledDate.startTime)} to ${convertTo12Hour(timeScheduledDate.endTime)})`);
                                        return;
                                    }
                                    setEditData((prev) => ({
                                        ...prev,
                                        startTime: e.target.value,
                                    }))
                                }}
                            />
                        </Form.Group>

                        {/* End Time */}
                        <Form.Group className="mb-3">
                            <Form.Label>End Time</Form.Label>
                            <Form.Control
                                type="time"
                                value={editData.endTime}
                                placeholder="23:59"
                                disabled={editDataWholeDay}
                                min={timeScheduledDate?.startTime}
                                max={timeScheduledDate?.endTime}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (value < timeScheduledDate.startTime || value > timeScheduledDate.endTime) {
                                        toast.error(`End time should be within allowed range (${convertTo12Hour(editData.startTime)} to ${convertTo12Hour(timeScheduledDate.endTime)})`);
                                        return;
                                    }

                                    if (value < editData.startTime) {
                                        toast.error("End time cannot be less than start time");
                                        return;
                                    }
                                    setEditData((prev) => ({
                                        ...prev,
                                        endTime: e.target.value,
                                    }))
                                }}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Select Days</Form.Label>
                            <div>
                                {timeScheduledDate?.weekDays.map((day) => (
                                    <Form.Check
                                        inline
                                        key={day}
                                        label={day}
                                        type="checkbox"
                                        checked={editData?.weekDays?.includes(day)}
                                        onChange={(e) => {
                                            setEditData((prev) => ({
                                                ...prev,
                                                weekDays: e.target.checked
                                                    ? [...prev.weekDays, day]
                                                    : prev.weekDays.filter((d) => d !== day),
                                            }));
                                        }}
                                    />
                                ))}
                            </div>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>
                                Priority <span style={{ color: "red", margin: "0 4px" }}>*</span>
                            </Form.Label>
                            <Form.Control
                                type="number"
                                name="priority"
                                min="0"
                                max="10"
                                required
                                value={editData.priority}
                                placeholder={priorityError ? "Priority is required (0-10)" : "Enter priority (0-10)"}
                                style={{
                                    borderColor: priorityError ? '#dc3545' : undefined,
                                    backgroundColor: priorityError ? '#fff5f5' : undefined
                                }}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const numValue = parseInt(value);
                                    
                                    // Validate on change
                                    if (value === '') {
                                        setPriorityError(true);
                                        setEditData((prev) => ({
                                            ...prev,
                                            priority: value,
                                        }));
                                    } else if (isNaN(numValue) || numValue < 0 || numValue > 10) {
                                        setPriorityError(true);
                                        setEditData((prev) => ({
                                            ...prev,
                                            priority: value,
                                        }));
                                    } else {
                                        setPriorityError(false);
                                        setEditData((prev) => ({
                                            ...prev,
                                            priority: value,
                                        }));
                                    }
                                }}
                            />
                            {priorityError && (
                                <Form.Text className="text-danger" style={{ fontSize: '0.875rem' }}>
                                    {!editData.priority || editData.priority === '' 
                                        ? "Priority is required and must be a number between 0 and 10"
                                        : "Priority must be a number between 0 and 10"
                                    }
                                </Form.Text>
                            )}
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEditModal(false)}>
                        Close
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleSaveAgentEdit}
                        disabled={savingAgentSchedule}
                    >
                        {savingAgentSchedule ? 'Saving...' : 'Save Changes'}
                    </Button>

                </Modal.Footer>
                           <div
                            style={{
                              background: "#FFF8C6",
                              color: "#8B5A2B",
                              padding: "8px 12px",
                              borderRadius: "6px",
                              display: "flex",
                              alignItems: "center",
                              fontSize: "14px",
                              fontWeight: 500,
                              margin: "10px"
                            }}
                          >
                            <span>
                              <strong>Note: </strong>Member’s Time Schedule must fall within the Range of Call Group Time Schedule.
                            </span>
                          </div>
            </Modal>




        </div>
    );
};

export default GroupSettings;
